import dayjs from 'dayjs';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import isNumber from 'is-number';
import 'dayjs/locale/th';

dayjs.extend(buddhistEra);

const getHoursAndMinutes = (totalMinutes) => {
  let hours = Math.floor(totalMinutes / 60);
  let minute = Math.ceil(totalMinutes % 60);
  if (minute >= 60) {
    minute -= 60;
    hours += 1;
  }
  return { hours, minute };
};

export const getDuration = (seconds) => {
  if (isNumber(seconds)) {
    if (seconds >= 0) {
      const totalMinutes = seconds / 60;
      const { hours, minute } = getHoursAndMinutes(totalMinutes);
      return `${hours} ชั่วโมง ${minute} นาที`;
    } else {
      return `0 ชั่วโมง 0 นาที`;
    }
  }
  return null;
};

export const getDurationWithoutHour = (seconds, lang = 'TH') => {
  if (isNumber(seconds)) {
    if (seconds >= 0) {
      const totalMinutes = seconds / 60;
      const { hours, minute } = getHoursAndMinutes(totalMinutes);
      if (hours === 0) {
        if (seconds < 60) {
          return '1 m';
        }
        return lang === 'TH' ? `${minute} นาที` : `${minute} m`;
      }
      return lang === 'TH' ? `${hours} ชั่วโมง ${minute} นาที` : `${hours} hr ${minute} m`;
    } else {
      return lang === 'TH' ? `0 ชั่วโมง 0 นาที` : '0 hr 0 m';
    }
  }
  return null;
};

export const localeDate = (date, lang, format = 'D MMMM YYYY') => {
  return dayjs(date).locale(lang).format(format);
};

const formatTime = (time) => {
  return ('0' + time).slice(-2);
};

export const secondsToTime = (s, { autoHideHour = false } = {}) => {
  if (s === 0) {
    if (autoHideHour) return `${formatTime(0)}:${formatTime(0)}`;
    return `${formatTime(0)}:${formatTime(0)}:${formatTime(0)}`;
  }
  if (!s) return '';

  let secs = Number.isInteger(s) ? s : parseInt(s);
  let min = Math.floor(secs / 60);
  secs = secs % 60;
  const hour = Math.floor(min / 60);
  min = min % 60;
  if (autoHideHour && hour === 0) return `${formatTime(min)}:${formatTime(secs)}`;
  return `${formatTime(hour)}:${formatTime(min)}:${formatTime(secs)}`;
};
